/**
 * Utilidades helper para Meta Conversions API y Facebook Pixel
 */

/**
 * Obtiene una cookie por su nombre
 * @param {string} name - Nombre de la cookie
 * @returns {string|null} - Valor de la cookie o null si no existe
 */
export function getCookie(name) {
  if (typeof window === 'undefined') return null;
  
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

/**
 * Genera un event_id único para deduplicación entre Pixel y CAPI
 * @param {string} eventType - Tipo de evento (ej: 'addtocart', 'purchase')
 * @param {string|number} identifier - Identificador único (productId, orderId, etc.)
 * @returns {string} - Event ID único
 */
export function generateEventId(eventType, identifier = '') {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substr(2, 9);
  const identifierStr = identifier ? `_${identifier}` : '';
  return `${eventType}${identifierStr}_${timestamp}_${random}`;
}

/**
 * Obtiene los datos del usuario desde localStorage
 * @returns {object|null} - Datos del usuario o null si no está logueado
 */
export function getUserData() {
  if (typeof window === 'undefined') return null;
  
  try {
    const userData = localStorage.getItem('user');
    return userData ? JSON.parse(userData) : null;
  } catch (error) {
    console.error('Error obteniendo datos del usuario:', error);
    return null;
  }
}

/**
 * Construye el objeto user_data para Meta Conversions API
 * @param {object} user - Objeto de usuario (opcional)
 * @returns {object} - Objeto user_data para CAPI
 */
export function buildUserData(user = null) {
  const userData = user || getUserData();
  
  const userDataObj = {
    client_user_agent: typeof window !== 'undefined' ? navigator.userAgent : null,
    fbp: getCookie('_fbp'), // Facebook Browser ID
    fbc: getCookie('_fbc'), // Facebook Click ID
  };

  if (userData) {
    if (userData.email) {
      userDataObj.email = userData.email;
    }
    if (userData.phone) {
      userDataObj.phone = userData.phone;
    }
    if (userData.id) {
      userDataObj.external_id = userData.id.toString();
    }
    if (userData.name) {
      const nameParts = userData.name.split(' ');
      if (nameParts.length > 0) {
        userDataObj.first_name = nameParts[0];
      }
      if (nameParts.length > 1) {
        userDataObj.last_name = nameParts.slice(1).join(' ');
      }
    }
    if (userData.first_name) {
      userDataObj.first_name = userData.first_name;
    }
    if (userData.last_name) {
      userDataObj.last_name = userData.last_name;
    }
  }

  return userDataObj;
}

/**
 * Obtiene la URL base de la API desde las variables de entorno
 * @returns {string} - URL base de la API
 */
export function getApiUrl() {
  return process.env.BASE_URL || '';
}

